// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import { jsonMember, jsonObject } from "typedjson";
import {
  ChannelAsset,
  deserializeChannelAsset,
  serializeChannelAsset,
} from "./types/channelState";

@jsonObject()
export default class GetQuote extends PerunMessage {
  @jsonMember({
    deserializer: deserializeChannelAsset,
    serializer: serializeChannelAsset,
  })
  fromAsset: ChannelAsset;
  @jsonMember({
    deserializer: deserializeChannelAsset,
    serializer: serializeChannelAsset,
  })
  toAsset: ChannelAsset;
  @jsonMember(String) hub: string;

  constructor(
    fromAsset: ChannelAsset,
    toAsset: ChannelAsset,
    hubAddress: string,
  ) {
    super();
    this.fromAsset = fromAsset;
    this.toAsset = toAsset;
    this.hub = hubAddress;
  }

  messageType(): MessageType {
    return GetQuote;
  }

  messageTypeName(): MessageTypeName {
    return "GetQuote";
  }
}
